import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/campaign.service";
import {
  ICreateCampaign,
  ICreateTestCall,
  IUpdateCampaign,
} from "../../models/campaign.model";

export const createCampaignThunk = createAsyncThunk(
  "campaign/createCampaign",
  async (payload: ICreateCampaign, { rejectWithValue }) => {
    try {
      const response = await api.createCampaign(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Create campaign failed"
      );
    }
  }
);

export const uploadFileThunk = createAsyncThunk(
  "campaign/uploadFile",
  async (payload: { file: File; agentId?: string }, { rejectWithValue }) => {
    try {
      const response = await api.uploadFile(payload.file, payload.agentId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Upload file failed"
      );
    }
  }
);

export const getCampaignsThunk = createAsyncThunk(
  "campaign/getCampaigns",
  async (
    payload: {
      page: number;
      limit: number;
      keyword: string;
      status: string;
      directionFilter: string;
      sort?: Record<string, 1 | -1>;
      start_date?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.getCampaigns(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get campaigns failed"
      );
    }
  }
);

export const getCampaignByIdThunk = createAsyncThunk(
  "campaign/getCampaignById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await api.getCampaignById(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get campaign by id failed"
      );
    }
  }
);

export const updateCampaignThunk = createAsyncThunk(
  "campaign/updateCampaign",
  async (
    { id, payload }: { id: string; payload: IUpdateCampaign },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.updateCampaign(id, payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Update campaign failed"
      );
    }
  }
);

export const getCampaignReportThunk = createAsyncThunk(
  "campaign/getCampaignReport",
  async (
    payload: {
      campaignId?: string;
      agentId?: string;
      page?: number;
      limit?: number;
      keyword?: string;
      direction?: string;
      sort?: Record<string, 1 | -1>;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.getCampaignReport(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get campaign report failed"
      );
    }
  }
);

export const createTestCallThunk = createAsyncThunk(
  "campaign/createTestCall",
  async (payload: ICreateTestCall, { rejectWithValue }) => {
    try {
      const response = await api.createTestCall(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Create test call failed"
      );
    }
  }
);

export const deleteCampaignThunk = createAsyncThunk(
  "campaign/deleteCampaign",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await api.deleteCampaign(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Delete campaign failed"
      );
    }
  }
);

export const getListAudiencesThunk = createAsyncThunk(
  "campaign/getListAudience",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.getListAudiences();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get list audiences failed"
      );
    }
  }
);
